export const objectToFormData = (obj, parentKey = '', formData = new FormData()) => {
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            let propName = parentKey ? `${parentKey}.${key}` : key
            if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key]) && !(obj[key] instanceof File) && !(obj[key] instanceof Blob)) {
                objectToFormData(obj[key], propName, formData)
            } else if (Array.isArray(obj[key])) {
                obj[key].forEach((item, index) => {
                    if (typeof item === 'object' && item !== null) {
                        objectToFormData(item, `${propName}[${index}]`, formData)
                    } else {
                        formData.append(`${propName}[]`, item)
                    }
                })
            } else {
                const v = obj[key] === null ? '' : obj[key]
                formData.append(propName, v)
            }
        }
    }
    return formData
}

/**
 * Búsqueda de una clave dado su valor dentro de un objeto/array
 * 
 * Ejemplos de uso:
 * const foo = { data: { data2: { data3: 'worked' }, data21: 'rand' }, data4: { id: 15, name: 'find me!' } }
 * console.log(findKeyByValue(foo, (found) => found === 'worked'))
 * console.log(findKeyByValue(foo, (found) => found && found.id && found.id === 15))
 * @param {*} obj Objeto/Array en el que realizar la búsqueda
 * @param {*} equalsExpression Expresión para localizar la clave del objeto/array
 * @returns Devuelve la clave del objeto/array
 */
export const findKeyByValue = (obj, equalsExpression) => {
    for (var [key, v] of Object.entries(obj)) {
        if (Array.isArray(v)) {
            for (let i = 0; i < v.length; i++) {
                let res = findKeyByValue(v[i], equalsExpression)
                if (res !== null && res !== undefined) return res
            }
        } else {
            if (v !== null && v !== undefined) {
                if (typeof (v) === 'object') {
                    if (equalsExpression(v)) return key
                    let res = findKeyByValue(v, equalsExpression)
                    if (res !== null && res !== undefined) return res
                }
                else {
                    let res = equalsExpression(v)
                    if (res) return key
                }
            }
            else continue
        }
    }
}

/**
 * Búsqueda de un valor dada su clave dentro de un objeto
 * @param {*} object Objeto en el que realizar la búsqueda
 * @param {*} key Clave a buscar dentro del objeto
 * @returns Devuelve el valor del objeto
 */
export const findValueByKey = (object, key) => {
    let value
    Object.keys(object).some(k => {
        if (k === key) {
            value = object[k]
            return true
        }
        if (object[k] && typeof object[k] === 'object') {
            value = findValueByKey(object[k], key)
            return value !== undefined
        }
    })
    return value
}

export const removeByKey = (arr, removingKey) => arr.filter(x => x.key !== removingKey).map(x => ({ ...x, children: removeByKey(x.children || [], removingKey) }))

export const objectToQueryString = obj => {
    const keyValuePairs = []
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const value = obj[key]
            if (Array.isArray(value)) {
                value.forEach(item => {
                    keyValuePairs.push(`${encodeURIComponent(key)}=${encodeURIComponent(item)}`)
                })
            } else {
                keyValuePairs.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
            }
        }
    }
    return keyValuePairs.join('&')
}

export const removeNullProperties = obj => Object.fromEntries(Object.entries(obj).filter(([_, v]) => v !== null))

export const filterProperties = (originalObject, properties, filterEmptyValues = true) => {
    const filteredProperties = filterEmptyValues ? properties.filter(key => originalObject[key] !== null && originalObject[key] !== undefined && originalObject[key] !== '') : properties
    return filteredProperties.reduce((obj, key) => ({ ...obj, [key]: originalObject[key] }), {})
}

/**
 * Reemplaza variables dentro de un objeto
 * @param {*} jsonObject Objeto en el que realizar el reemplazo
 * @param {*} variables Objeto con los valores a reemplazar
 * @returns Devuelve el valor del objeto
 */
export const replaceIntoObject = (jsonObject, variables) => {
    const updatedObject = JSON.parse(JSON.stringify(jsonObject))

    const replaceRecursively = obj => {
        for (const key in obj) {
            if (typeof obj[key] === 'object') {
                replaceRecursively(obj[key])
            } else if (typeof obj[key] === 'string') {
                let match
                const regex = /\${(\w+)}/g 
                while ((match = regex.exec(obj[key])) !== null) {
                    const variableName = match[1]
                    const newValue = variables[variableName]
                    if (newValue !== undefined && (!isNaN(obj[key]) || !isNaN(newValue))) {
                        obj[key] = Number(newValue)
                    } else {
                        obj[key] = obj[key].replace(match[0], newValue)
                    }
                }
            }
        }
    }

    replaceRecursively(updatedObject)
    return updatedObject
}